export default __webpack_public_path__ + "static/smart-scrollbar-87dcac02a6b6aa85c42edb89d03bdb41.gif";